// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__d1PW6","insightsList":"newBusinessInsightsMenu_insightsList__1kZnR","active":"newBusinessInsightsMenu_active__Nieb7"};